import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext({ settings: null, catalog: null });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [catalog, setCatalog] = useState(null);

  const reload = useCallback(() => {
    api.get("/public/settings").then((r) => setSettings(r.data)).catch(() => {});
    api.get("/public/catalog").then((r) => setCatalog(r.data)).catch(() => {});
  }, []);

  useEffect(() => { reload(); }, [reload]);

  useEffect(() => {
    const c = settings?.colors;
    if (c) {
      const root = document.documentElement.style;
      root.setProperty("--kc-bg", c.background); root.setProperty("--kc-text", c.text); root.setProperty("--kc-blue", c.primary);
      root.setProperty("--kc-terracotta", c.terracotta); root.setProperty("--kc-gold", c.gold);
    }
  }, [settings]);

  const fallCampaign = catalog?.campaigns?.find((c) => c.theme === "fall" || c.theme === "festival");
  return (
    <SettingsContext.Provider value={{ settings, catalog, reload, fallCampaign }}>{children}</SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
